import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  MenuItem,
  Paper,
  styled,
  SvgIcon,
  Tab,
  Tabs,
  Tooltip,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
  colorPrimary,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import _ from 'lodash';
import {
  styledMenuItem,
  StyledSelect
} from '../../containers/productanalytics/UserAndRoleAnalytics';
import { Calendar01Icon, FilterLinesIcon } from '../../utils/iconSvg';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { useDispatch } from 'react-redux';
import {
  deleteAllHistory,
  getHistoryList,
  revertResources
} from '../../redux/reducers/resourcesSlice';
import { useSelector } from 'react-redux';
import ContentCard from '../../containers/Resources/ContentCard';
import { useNavigate } from 'react-router-dom';
import ConfirmBox from '../../components/ConfirmBox';
import {
  getGamificationPoints,
  setActiveModule
} from '../../redux/reducers/layoutSlice';
import { createTitle } from '../../utils/utils';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,

  marginLeft: 0,
  marginRight: 10,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto'
  }
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  // padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  right: 6,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

let searchValue = '';
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 1.5),
    paddingRight: `calc(1em + ${theme.spacing(2)})`,
    transition: theme.transitions.create('width'),
    width: searchValue ? '26ch' : '0px',
    border: searchValue ? '1px solid #CBD2D9' : '',
    borderRadius: searchValue ? '8px' : '',
    [theme.breakpoints.up('sm')]: {
      '&:focus': {
        width: searchValue ? '26ch' : '26ch',
        border: '1px solid #CBD2D9',
        borderRadius: '8px'
      }
    }
  }
}));

function History() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [initialValues, setInitalValues] = useState({
    tabValue: 0,
    page: 0,
    size: 20,
    searchFilter: ''
  });
  const [tempDateFilter, setTempDateFilter] = useState({
    dateType: null,
    startDate: null,
    endDate: null,
    sortBy: null
  });

  const [chart1Payload, setChart1Payload] = useState({
    dateType: 'all',
    startDate: null,
    endDate: null
  });

  const [open, setOpen] = useState(false);
  const [openCalenderModal, setOpenCalendarModal] = useState({
    startDate: false,
    endDate: false
  });
  const [isHover, setIshover] = useState(false);
  const [confirmation, setConfirmation] = useState(null);

  const {
    historyList,
    isDeleteHistorySuccess,
    isUpdateLikeDislikeSuccess,
    isGamificationLoading,
    isGamificationSuccess,
    isDeleteGamificationLoading,
    isDeleteGamificationSuccess
  } = useSelector(state => state.resource);
  const { authData } = useSelector(state => state.auth);

  useEffect(() => {
    document.title = createTitle('History');
    dispatch(setActiveModule('History'));
    dispatch(revertResources());
  }, []);

  useEffect(() => {
    if (!isGamificationLoading && isGamificationSuccess) {
      dispatch(getGamificationPoints(authData?.userId || 0));
    }
    if (!isDeleteGamificationLoading && isDeleteGamificationSuccess) {
      dispatch(getGamificationPoints(authData?.userId || 0));
    }
  }, [
    isGamificationLoading,
    isGamificationSuccess,
    isDeleteGamificationLoading,
    isDeleteGamificationSuccess
  ]);

  useEffect(() => {
    dispatch(getGamificationPoints(authData?.userId || 0));
    // dispatch(revertResources());
    dispatch(
      getHistoryList({
        payload: {
          userId: authData?.userId,
          contentType:
            initialValues.tabValue === 0
              ? 'All'
              : initialValues.tabValue === 1
                ? 'Video'
                : initialValues.tabValue === 2
                  ? 'Documents'
                  : initialValues.tabValue === 3
                    ? 'Audio'
                    : '',
          startDate: chart1Payload.startDate
            ? dayjs(chart1Payload.startDate).format('YYYY-MM-DD')
            : null,
          endDate: chart1Payload.endDate
            ? dayjs(chart1Payload.endDate).format('YYYY-MM-DD')
            : null,
          dateType: chart1Payload.dateType,
          // sortBy: tempDateFilter.sortBy,
          paginationRequest: {
            type: 'all',
            page: initialValues.page,
            size: initialValues.size
          }
        },
        search: initialValues.searchFilter
        // contentType:
        //   initialValues.tabValue === 1
        //     ? ''
        //     : initialValues.tabValue === 2
        //       ? 'All'
        //       : initialValues.tabValue === 3
        //         ? 'Registered'
        //         : initialValues.tabValue === 4
        //           ? 'PAF Only'
        //           : '',
        // status:
        //   initialValues.tabValue === 1
        //     ? 'Saved'
        //     : initialValues.tabValue === 2
        //       ? 'Publish'
        //       : initialValues.tabValue === 3
        //         ? 'Publish'
        //         : initialValues.tabValue === 4
        //           ? 'Publish'
        //           : ''
      })
    );
  }, [
    initialValues,
    chart1Payload,
    tempDateFilter,
    isDeleteHistorySuccess,
    isUpdateLikeDislikeSuccess
  ]);

  const debouncedSearch = _.debounce(
    term => setInitalValues({ ...initialValues, searchFilter: term, page: 0 }),
    300
  );

  const handleSearch = e => {
    const term = e.target.value;
    // setSearch(term);
    if (term.length >= 3 || term.length === 0) {
      debouncedSearch(term);
    }
  };

  const handleOpenCalendar = type => {
    setOpenCalendarModal({ ...openCalenderModal, [type]: true });
  };

  const handleCloseCalendar = type => {
    setOpenCalendarModal({ ...openCalenderModal, [type]: false });
  };

  const handleDeleteHistory = () => {
    const userId = authData?.userId;
    dispatch(deleteAllHistory({ userId }));
    setConfirmation(false);
  };

  return (
    <>
      <Grid sx={{ padding: '18px 0px' }} width={'100%'}>
        <Grid
          display={'flex'}
          justifyContent={'space-between'}
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            marginBottom: '8px'
          }}
        >
          <Tabs
            value={initialValues.tabValue}
            onChange={(val, newValue) => {
              setInitalValues({
                ...initialValues,
                tabValue: newValue,
                page: 0
              });
              dispatch(revertResources());
            }}
            TabIndicatorProps={{
              sx: {
                height: '4px',
                borderRadius: '4px'
              }
            }}
          >
            <Tab
              sx={{
                fontSize: '16px',
                fontWeight: '700',
                minHeight: 44,
                height: 44,
                color: colorTextGrey,

                '&.Mui-selected': {
                  color:
                    initialValues.tabValue === 0
                      ? colorTextBlack
                      : colorTextGrey
                }
              }}
              icon={
                <SvgIcon sx={{ height: '18px', width: '18px' }}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 9.375V5.1C13 3.83988 13 3.20982 12.7548 2.72852C12.539 2.30516 12.1948 1.96095 11.7715 1.74524C11.2902 1.5 10.6601 1.5 9.4 1.5H4.6C3.33988 1.5 2.70982 1.5 2.22852 1.74524C1.80516 1.96095 1.46095 2.30516 1.24524 2.72852C1 3.20982 1 3.83988 1 5.1V12.9C1 14.1601 1 14.7902 1.24524 15.2715C1.46095 15.6948 1.80516 16.039 2.22852 16.2548C2.70982 16.5 3.33988 16.5 4.6 16.5H7M8.5 8.25H4M5.5 11.25H4M10 5.25H4M8.875 14.25L10.375 15.75L13.75 12.375"
                      stroke={
                        initialValues.tabValue === 0
                          ? colorTextBlack
                          : colorTextGrey
                      }
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SvgIcon>
              }
              iconPosition="start"
              label="All"
            />
            <Tab
              sx={{
                fontSize: '16px',
                fontWeight: '700',
                minHeight: 44,
                height: 44,
                color: colorTextGrey,
                '&.Mui-selected': {
                  color:
                    initialValues.tabValue === 1
                      ? colorTextBlack
                      : colorTextGrey
                }
              }}
              icon={
                <SvgIcon sx={{ height: '18px', width: '18px' }}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.5 6.69853C16.5 6.24417 16.5 6.01699 16.4102 5.91179C16.3322 5.82051 16.2152 5.77207 16.0956 5.78149C15.9577 5.79234 15.797 5.95298 15.4757 6.27426L12.75 9L15.4757 11.7257C15.797 12.047 15.9577 12.2077 16.0956 12.2185C16.2152 12.2279 16.3322 12.1795 16.4102 12.0882C16.5 11.983 16.5 11.7558 16.5 11.3015V6.69853Z"
                      stroke={
                        initialValues.tabValue === 1
                          ? colorTextBlack
                          : colorTextGrey
                      }
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1.5 7.35C1.5 6.08988 1.5 5.45982 1.74524 4.97852C1.96095 4.55516 2.30516 4.21095 2.72852 3.99524C3.20982 3.75 3.83988 3.75 5.1 3.75H9.15C10.4101 3.75 11.0402 3.75 11.5215 3.99524C11.9448 4.21095 12.289 4.55516 12.5048 4.97852C12.75 5.45982 12.75 6.08988 12.75 7.35V10.65C12.75 11.9101 12.75 12.5402 12.5048 13.0215C12.289 13.4448 11.9448 13.789 11.5215 14.0048C11.0402 14.25 10.4101 14.25 9.15 14.25H5.1C3.83988 14.25 3.20982 14.25 2.72852 14.0048C2.30516 13.789 1.96095 13.4448 1.74524 13.0215C1.5 12.5402 1.5 11.9101 1.5 10.65V7.35Z"
                      stroke={
                        initialValues.tabValue === 1
                          ? colorTextBlack
                          : colorTextGrey
                      }
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SvgIcon>
              }
              iconPosition="start"
              label="Videos"
            />
            <Tab
              sx={{
                fontSize: '16px',
                fontWeight: '700',
                minHeight: 44,
                height: 44,
                color: colorTextGrey,
                '&.Mui-selected': {
                  color:
                    initialValues.tabValue === 2
                      ? colorTextBlack
                      : colorTextGrey
                }
              }}
              icon={
                <SvgIcon sx={{ height: '18px', width: '18px' }}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5 1.70215V4.80005C10.5 5.22009 10.5 5.43011 10.5817 5.59055C10.6537 5.73167 10.7684 5.8464 10.9095 5.91831C11.0699 6.00005 11.28 6.00005 11.7 6.00005H14.7979M10.5 12.75H6M12 9.75H6M15 7.49117V12.9C15 14.1601 15 14.7902 14.7548 15.2715C14.539 15.6948 14.1948 16.039 13.7715 16.2548C13.2902 16.5 12.6601 16.5 11.4 16.5H6.6C5.33988 16.5 4.70982 16.5 4.22852 16.2548C3.80516 16.039 3.46095 15.6948 3.24524 15.2715C3 14.7902 3 14.1601 3 12.9V5.1C3 3.83988 3 3.20982 3.24524 2.72852C3.46095 2.30516 3.80516 1.96095 4.22852 1.74524C4.70982 1.5 5.33988 1.5 6.6 1.5H9.00883C9.55916 1.5 9.83432 1.5 10.0933 1.56217C10.3229 1.61729 10.5423 1.7082 10.7436 1.83156C10.9707 1.9707 11.1653 2.16527 11.5544 2.55442L13.9456 4.94558C14.3347 5.33473 14.5293 5.5293 14.6684 5.75636C14.7918 5.95767 14.8827 6.17715 14.9378 6.40673C15 6.66568 15 6.94084 15 7.49117Z"
                      stroke={
                        initialValues.tabValue === 2
                          ? colorTextBlack
                          : colorTextGrey
                      }
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SvgIcon>
              }
              iconPosition="start"
              label="Documents"
            />
            <Tab
              sx={{
                fontSize: '16px',
                fontWeight: '700',
                minHeight: 44,
                height: 44,
                color: colorTextGrey,
                '&.Mui-selected': {
                  color:
                    initialValues.tabValue === 3
                      ? colorTextBlack
                      : colorTextGrey
                }
              }}
              icon={
                <SvgIcon sx={{ height: '18px', width: '18px' }}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.25 7.5V9C14.25 11.8995 11.8995 14.25 9 14.25M3.75 7.5V9C3.75 11.8995 6.10051 14.25 9 14.25M9 14.25V16.5M6 16.5H12M9 11.25C7.75736 11.25 6.75 10.2426 6.75 9V3.75C6.75 2.50736 7.75736 1.5 9 1.5C10.2426 1.5 11.25 2.50736 11.25 3.75V9C11.25 10.2426 10.2426 11.25 9 11.25Z"
                      stroke={
                        initialValues.tabValue === 3
                          ? colorTextBlack
                          : colorTextGrey
                      }
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SvgIcon>
              }
              iconPosition="start"
              label="Audio"
            />
            {/* <Tab
              sx={{
                fontSize: '16px',
                fontWeight: '700',
                minHeight: 44,
                height: 44,
                color: colorTextGrey,
                '&.Mui-selected': {
                  color:
                    initialValues.tabValue === 3
                      ? colorTextBlack
                      : colorTextGrey
                }
              }}
              icon={
                <SvgIcon sx={{ height: '18px', width: '18px' }}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 6H1M1 4.2L1 11.8C1 12.9201 1 13.4802 1.21799 13.908C1.40973 14.2843 1.71569 14.5903 2.09202 14.782C2.51984 15 3.07989 15 4.2 15L17.8 15C18.9201 15 19.4802 15 19.908 14.782C20.2843 14.5903 20.5903 14.2843 20.782 13.908C21 13.4802 21 12.9201 21 11.8V4.2C21 3.0799 21 2.51984 20.782 2.09202C20.5903 1.7157 20.2843 1.40974 19.908 1.21799C19.4802 1 18.9201 1 17.8 1L4.2 1C3.0799 1 2.51984 1 2.09202 1.21799C1.7157 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2Z"
                      stroke={
                        initialValues.tabValue === 3
                          ? colorTextBlack
                          : colorTextGrey
                      }
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SvgIcon>
              }
              iconPosition="start"
              label="Flashcards"
            /> */}
          </Tabs>
        </Grid>
        <Grid
          container
          display={'flex'}
          flexDirection={'column'}
          elevation={0}
          component={Paper}
          borderRadius={'8px'}
          sx={{ paddingX: '14px' }}
        >
          {/* Date and Search */}
          <Box display={'flex'} justifyContent={'space-between'}>
            <Box sx={{ width: '255px' }} marginY={1.5}>
              <FormControl variant="outlined" fullWidth size="small">
                <StyledSelect
                  IconComponent={Calendar01Icon}
                  size="small"
                  open={open}
                  value={
                    open ? tempDateFilter.dateType : chart1Payload.dateType
                  }
                  onOpen={(e, va) => {
                    setOpen(true);
                    setTempDateFilter({
                      ...tempDateFilter,
                      dateType: chart1Payload.dateType,
                      startDate: chart1Payload.startDate,
                      endDate: chart1Payload.endDate
                    });
                  }}
                  onChange={e => {
                    setTempDateFilter({
                      ...tempDateFilter,
                      dateType: e.target.value,
                      startDate: null,
                      endDate: null
                    });
                  }}
                  renderValue={value => {
                    let data = open ? tempDateFilter : chart1Payload;
                    if (data.dateType == 'all') {
                      return (
                        <Typography
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#ABB4BD'
                          }}
                        >
                          <SvgIcon fontSize="small" sx={{ marginRight: 1 }}>
                            <FilterLinesIcon color="#ABB4BD" />
                          </SvgIcon>
                          Select date
                        </Typography>
                      );
                    }
                    switch (data.dateType) {
                      case 'selected_date':
                        return `${data.startDate ? dayjs(data.startDate).format('DD/MM/YY') : ''} - ${data.endDate ? dayjs(data.endDate).format('DD/MM/YY') : ''}`;
                      case 'Week':
                        return 'Last Week';
                      case 'Month':
                        return 'This Month';
                      case 'past_3_months':
                        return 'Past 3 months';
                      case 'Past_1_Year':
                        return 'Past 1 year';
                      default:
                        return;
                    }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#CBD2D9'
                    },
                    '&:hover  .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#CBD2D9'
                    },
                    '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#CBD2D9'
                    },
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 8
                    }
                  }}
                >
                  <MenuItem
                    sx={{ ...styledMenuItem, paddingX: 0, border: 'none' }}
                    value="selected_date"
                    disableRipple
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box display={'flex'} gap={1}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          sx={{ width: '175px' }}
                        >
                          <Typography
                            sx={{
                              fontSize: '14px',
                              fontWeight: 600,
                              mb: 0.5
                            }}
                          >
                            Start Date
                          </Typography>
                          <DatePicker
                            maxDate={dayjs()}
                            value={dayjs(tempDateFilter.startDate)}
                            onOpen={() => handleOpenCalendar('startDate')}
                            onClose={() => handleCloseCalendar('startDate')}
                            open={openCalenderModal.startDate}
                            format="DD/MM/YYYY"
                            slotProps={{
                              textField: {
                                size: 'small',
                                placeholder: 'Start Date',
                                error: false,
                                InputProps: {
                                  sx: { color: colorTextBlack },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          handleOpenCalendar('startDate')
                                        }
                                      >
                                        <SvgIcon
                                          sx={{
                                            width: '16px',
                                            height: '16px',
                                            ml: 1
                                          }}
                                        >
                                          <Calendar01Icon />
                                        </SvgIcon>
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                },
                                sx: {
                                  paddingRight: 0 // Remove extra padding from the hidden icon
                                }
                              }
                            }}
                            onChange={date =>
                              setTempDateFilter({
                                ...tempDateFilter,
                                dateType: 'selected_date',
                                startDate: date,
                                endDate: date
                              })
                            }
                            components={{ OpenPickerIcon: () => null }}
                          />
                        </FormControl>
                        <FormControl
                          variant="outlined"
                          size="small"
                          sx={{ width: '175px' }}
                        >
                          <Typography
                            sx={{
                              fontSize: '14px',
                              fontWeight: 600,
                              mb: 0.5
                            }}
                          >
                            End Date
                          </Typography>
                          <DatePicker
                            minDate={dayjs(tempDateFilter.startDate)}
                            maxDate={dayjs()}
                            // label="End Date"
                            value={dayjs(tempDateFilter.endDate)}
                            open={openCalenderModal.endDate}
                            onOpen={() => handleOpenCalendar('endDate')}
                            onClose={() => handleCloseCalendar('endDate')}
                            format="DD/MM/YYYY"
                            slotProps={{
                              textField: {
                                size: 'small',
                                error: false,
                                InputProps: {
                                  sx: { color: colorTextBlack },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        size="small"
                                        onClick={() =>
                                          handleOpenCalendar('endDate')
                                        }
                                      >
                                        <SvgIcon
                                          sx={{
                                            width: '16px',
                                            height: '16px',
                                            ml: 1
                                          }}
                                        >
                                          <Calendar01Icon />
                                        </SvgIcon>
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                },
                                sx: {
                                  paddingRight: 0 // Remove extra padding from the hidden icon
                                }
                              }
                            }}
                            onChange={date => {
                              setTempDateFilter({
                                ...tempDateFilter,
                                dateType: 'selected_date',
                                endDate: date
                              });
                            }}
                            components={{ OpenPickerIcon: () => null }}
                            // components={{
                            //   OpenPickerIcon: props => (
                            //     <IconButton size="small" {...props}>
                            //       <Calendar01Icon />
                            //     </IconButton>
                            //   )
                            // }}
                          />
                        </FormControl>
                      </Box>
                    </LocalizationProvider>
                  </MenuItem>

                  <MenuItem sx={styledMenuItem} value="Week" disableRipple>
                    Last Week
                  </MenuItem>
                  <MenuItem sx={styledMenuItem} value="Month" disableRipple>
                    This Month
                  </MenuItem>
                  <MenuItem
                    sx={styledMenuItem}
                    value="past_3_months"
                    disableRipple
                  >
                    Past 3 month
                  </MenuItem>
                  <MenuItem
                    sx={styledMenuItem}
                    value="Past_1_Year"
                    disableRipple
                  >
                    Past 1 year
                  </MenuItem>
                  <MenuItem
                    // disabled={
                    //   !(tempDateFilter.dateType || chart1Payload.dateFilter)
                    // }
                    sx={{
                      border: '1px solid #E4E7EB',
                      backgroundColor: colorPrimary,
                      marginX: 1,
                      borderRadius: 3,
                      fontWeight: 700,
                      fontSize: '14px',
                      justifyContent: 'center',
                      marginY: 1,
                      '&:hover': {
                        background: colorPrimary
                      }
                    }}
                    onClick={() => {
                      if (tempDateFilter.dateType) {
                        setChart1Payload({
                          ...chart1Payload,
                          dateType: tempDateFilter.dateType,
                          startDate: tempDateFilter.startDate,
                          endDate: tempDateFilter.endDate
                        });
                      }
                      setTempDateFilter({
                        dateType: null,
                        endDate: null,
                        startDate: null
                      });
                      setOpen(false);
                    }}
                  >
                    Apply
                  </MenuItem>
                  <MenuItem
                    // disabled={
                    //   !(tempDateFilter.dateType || chart1Payload.dateFilter)
                    // }
                    sx={{
                      border: '1px solid #E4E7EB',
                      backgroundColor: colorPrimary,
                      marginX: 1,
                      borderRadius: 3,
                      fontWeight: 700,
                      fontSize: '14px',
                      justifyContent: 'center',
                      marginY: 1,
                      '&:hover': {
                        background: colorPrimary
                      }
                    }}
                    onClick={() => {
                      setChart1Payload({
                        ...chart1Payload,
                        dateType: 'all',
                        startDate: null,
                        endDate: null
                      });
                      setTempDateFilter({
                        startDate: null,
                        dateType: null,
                        endDate: null
                      });
                      setOpen(false);
                    }}
                  >
                    Close
                  </MenuItem>
                </StyledSelect>
              </FormControl>
            </Box>
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              {/* <Grid sx={{ width: '304px' }} marginY={1.5} marginRight={'12px'}> */}
              <Search>
                <SearchIconWrapper>
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 17.5L14.375 13.875M16.3333 9.16667C16.3333 12.8486 13.3486 15.8333 9.66667 15.8333C5.98477 15.8333 3 12.8486 3 9.16667C3 5.48477 5.98477 2.5 9.66667 2.5C13.3486 2.5 16.3333 5.48477 16.3333 9.16667Z"
                      stroke="#ABB4BD"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SearchIconWrapper>
                <StyledInputBase
                  onChange={e => {
                    searchValue = e.target.value;
                    handleSearch(e);
                  }}
                  placeholder="Search here…"
                />
              </Search>
              {/* </Grid> */}
              <div
                style={{
                  display: 'flex',
                  // justifyContent: 'space-between'
                  justifyContent: 'flex-end'
                }}
              >
                <Tooltip placement="top" title="Click to delete history">
                  <Button
                    sx={{
                      height: 30,
                      color: isHover ? colorPrimary : colorTextBlack,
                      borderBottom: `1px solid ${isHover ? colorPrimary : colorTextBlack}`,
                      borderRadius: 0
                    }}
                    // disabled={!(historyList?.contentList.length > 0)}
                    onClick={() => setConfirmation(true)}
                    size="small"
                  >
                    <SvgIcon
                      fontSize="small"
                      sx={{
                        marginRight: 0.6,
                        height: '24px',
                        width: '24px'
                      }}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.3333 6.99935V6.33268C15.3333 5.39926 15.3333 4.93255 15.1517 4.57603C14.9919 4.26243 14.7369 4.00746 14.4233 3.84767C14.0668 3.66602 13.6001 3.66602 12.6667 3.66602H11.3333C10.3999 3.66602 9.9332 3.66602 9.57668 3.84767C9.26308 4.00746 9.00811 4.26243 8.84832 4.57603C8.66667 4.93255 8.66667 5.39926 8.66667 6.33268V6.99935M10.3333 11.5827V15.7493M13.6667 11.5827V15.7493M4.5 6.99935H19.5M17.8333 6.99935V16.3327C17.8333 17.7328 17.8333 18.4329 17.5608 18.9677C17.3212 19.4381 16.9387 19.8205 16.4683 20.0602C15.9335 20.3327 15.2335 20.3327 13.8333 20.3327H10.1667C8.76654 20.3327 8.06647 20.3327 7.53169 20.0602C7.06129 19.8205 6.67883 19.4381 6.43915 18.9677C6.16667 18.4329 6.16667 17.7328 6.16667 16.3327V6.99935"
                          stroke={colorTextBlack}
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </SvgIcon>
                    Clear all watch history
                  </Button>
                </Tooltip>
              </div>
            </Box>
          </Box>

          {/* Date wise content */}
          {historyList?.contentList.length > 0 ? (
            <Box>
              {historyList?.contentList?.map(dateWiseContent => {
                return (
                  <>
                    <Box
                      display={'flex'}
                      justifyContent={'space-between'}
                      alignItems={'center'}
                      marginBottom={1}
                    >
                      <Typography
                        color={colorTextBlack}
                        fontSize={'16px'}
                        fontWeight={600}
                        key={dateWiseContent?.historyCreatedDt}
                      >
                        {dateWiseContent?.historyCreatedDt}
                      </Typography>
                      <Button
                        size="small"
                        color="primary"
                        variant="outlined"
                        sx={{
                          borderColor: colorPrimary,
                          borderRadius: '8px',
                          color: colorTextBlack,
                          borderWidth: '2px',
                          height: '36px',
                          width: '93px',
                          textTransform: 'none',
                          fontSize: '12px',
                          fontWeight: 700,
                          alignItems: 'center',
                          '&:hover': {
                            borderColor: colorPrimary,
                            backgroundColor: 'transparent',
                            borderRadius: '10px',
                            borderWidth: '2px'
                          }
                        }}
                        onClick={() => {
                          navigate('/content-space/history/all', {
                            state: {
                              apiDate: dateWiseContent?.historyDate,
                              displayDate: dateWiseContent?.historyCreatedDt
                            }
                          });
                        }}
                      >
                        View all
                      </Button>
                    </Box>
                    <Grid container spacing={2} marginBottom={2}>
                      {dateWiseContent?.contents?.map((content, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                          <ContentCard
                            video={content}
                            sectionID={content?.section}
                          />
                        </Grid>
                      ))}
                    </Grid>
                    <Divider sx={{ my: 1 }} />
                  </>
                );
              })}
            </Box>
          ) : (
            <Box display={'flex'} justifyContent={'center'} marginY={2}>
              <Typography fontWeight={600}>No content available</Typography>
            </Box>
          )}
        </Grid>
      </Grid>

      <ConfirmBox
        isOpen={confirmation}
        title="Delete watch history!"
        subtitle={`Are you sure you want to delete all watch history?`}
        handleClose={() => setConfirmation(null)}
        handleSubmit={handleDeleteHistory}
      />
    </>
  );
}

export default History;
